export default __webpack_public_path__ + "static/media/icon_rowcount_2rows.3ba71adc.png";